import { isMobile } from "../utils";

export class Hero {
  heroEthosLink: HTMLElement | null =
    document.getElementById("hero-ethos-link");
  headerLogo: HTMLElement | null = document.getElementById("header-logo");

  isMobile = isMobile();

  constructor() {
    this.initHero();
  }

  initHero = () => {
    const headerLogoIntersectionObserver = new IntersectionObserver(
      this.onHeaderLogoIntersection,
    );

    if (this.headerLogo) {
      headerLogoIntersectionObserver.observe(this.headerLogo);
    }
  };

  onHeaderLogoIntersection = (entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      this.heroEthosLink?.classList.toggle(
        "hero-section-scroll-button--hidden",
        !entry.isIntersecting,
      );
    });
  };
}
